<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { Primitive } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <Primitive
    v-bind="delegatedProps"
    :class="cn('h-full flex flex-col items-center justify-center gap-4 py-6 text-center text-sm', props.class)"
  >
    <slot />
  </Primitive>
</template>
